// Utility to get environment variables with runtime priority
// Priority: window._env_ (runtime from ConfigMap) > import.meta.env (build-time from .env)
export const getEnvsVariable = () => {
  return {
    // API Configuration
    VITE_API_URL: window._env_?.VITE_API_URL ?? import.meta.env.VITE_API_URL,
    VITE_API_TIMEOUT:
      window._env_?.VITE_API_TIMEOUT ?? import.meta.env.VITE_API_TIMEOUT,

    // Keycloak Configuration
    VITE_KEYCLOAK_URL:
      window._env_?.VITE_KEYCLOAK_URL ?? import.meta.env.VITE_KEYCLOAK_URL,
    VITE_KEYCLOAK_REALM:
      window._env_?.VITE_KEYCLOAK_REALM ?? import.meta.env.VITE_KEYCLOAK_REALM,
    VITE_KEYCLOAK_CLIENT_ID:
      window._env_?.VITE_KEYCLOAK_CLIENT_ID ??
      import.meta.env.VITE_KEYCLOAK_CLIENT_ID,

    // EMV API Configuration
    VITE_API_EMV_URL_GENERATE_CONTEXT:
      window._env_?.VITE_API_EMV_URL_GENERATE_CONTEXT ??
      import.meta.env.VITE_API_EMV_URL_GENERATE_CONTEXT,
    VITE_API_EMV_URL_PROCESS_TRANSACTION:
      window._env_?.VITE_API_EMV_URL_PROCESS_TRANSACTION ??
      import.meta.env.VITE_API_EMV_URL_PROCESS_TRANSACTION,
    VITE_API_EMV_URL_SGP_ID:
      window._env_?.VITE_API_EMV_URL_SGP_ID ??
      import.meta.env.VITE_API_EMV_URL_SGP_ID,
    VITE_API_EMV_URL_CACHE_COMPANY_ID:
      window._env_?.VITE_API_EMV_URL_CACHE_COMPANY_ID ??
      import.meta.env.VITE_API_EMV_URL_CACHE_COMPANY_ID,

    // User Utils API
    VITE_API_USER_UTILS_SUPERVISOR:
      window._env_?.VITE_API_USER_UTILS_SUPERVISOR ??
      import.meta.env.VITE_API_USER_UTILS_SUPERVISOR,
    // User API
    VITE_API_USER_API_EMAIL:
      window._env_?.VITE_API_USER_API_EMAIL ??
      import.meta.env.VITE_API_USER_API_EMAIL,

    // API Paths
    VITE_PATH_HEALTH:
      window._env_?.VITE_PATH_HEALTH ?? import.meta.env.VITE_PATH_HEALTH,
    VITE_PATH_EMV: window._env_?.VITE_PATH_EMV ?? import.meta.env.VITE_PATH_EMV,
    VITE_PATH_SUPERVISOR:
      window._env_?.VITE_PATH_SUPERVISOR ??
      import.meta.env.VITE_PATH_SUPERVISOR,
    VITE_PATH_INSPECTOR:
      window._env_?.VITE_PATH_INSPECTOR ?? import.meta.env.VITE_PATH_INSPECTOR,
    VITE_PATH_INSPECTION:
      window._env_?.VITE_PATH_INSPECTION ??
      import.meta.env.VITE_PATH_INSPECTION,
    VITE_INSPECTOR:
      window._env_?.VITE_INSPECTOR ?? import.meta.env.VITE_INSPECTOR,
    VITE_INSPECTOR_ALL:
      window._env_?.VITE_INSPECTOR_ALL ?? import.meta.env.VITE_INSPECTOR_ALL,
    VITE_GENDERS: window._env_?.VITE_GENDERS ?? import.meta.env.VITE_GENDERS,
    VITE_LINES: window._env_?.VITE_LINES ?? import.meta.env.VITE_LINES,
    VITE_COMPANIES:
      window._env_?.VITE_COMPANIES ?? import.meta.env.VITE_COMPANIES,
    VITE_PROVINCES:
      window._env_?.VITE_PROVINCES ?? import.meta.env.VITE_PROVINCES,
    VITE_MUNICIPALITIES:
      window._env_?.VITE_MUNICIPALITIES ?? import.meta.env.VITE_MUNICIPALITIES,
    VITE_JURISDICTIONS:
      window._env_?.VITE_JURISDICTIONS ?? import.meta.env.VITE_JURISDICTIONS,
    VITE_INSPECTOR_CHANGE_STATUS:
      window._env_?.VITE_INSPECTOR_CHANGE_STATUS ??
      import.meta.env.VITE_INSPECTOR_CHANGE_STATUS,
    VITE_INSPECTION_EXPORT_CSV:
      window._env_?.VITE_INSPECTION_EXPORT_CSV ??
      import.meta.env.VITE_INSPECTION_EXPORT_CSV,
    VITE_REPORT_DATEANDDNI:
      window._env_?.VITE_REPORT_DATEANDDNI ??
      import.meta.env.VITE_REPORT_DATEANDDNI,
    VITE_INSPECTION_MAP_POINTS:
      window._env_?.VITE_INSPECTION_MAP_POINTS ??
      import.meta.env.VITE_INSPECTION_MAP_POINTS,
    VITE_INSPECTION_DETAIL_V2:
      window._env_?.VITE_INSPECTION_DETAIL_V2 ??
      import.meta.env.VITE_INSPECTION_DETAIL_V2,
    VITE_EMV: window._env_?.VITE_EMV ?? import.meta.env.VITE_EMV,
    VITE_SUPERVISOR:
      window._env_?.VITE_SUPERVISOR ?? import.meta.env.VITE_SUPERVISOR,
    VITE_INSPECTION:
      window._env_?.VITE_INSPECTION ?? import.meta.env.VITE_INSPECTION,
    VITE_DNI_MASK_TYPE:
      window._env_?.VITE_DNI_MASK_TYPE ?? import.meta.env.VITE_DNI_MASK_TYPE,

    // controlsube emv
    VITE_PATH_CONTROLSUBE:
      window._env_?.VITE_PATH_CONTROLSUBE ??
      import.meta.env.VITE_PATH_CONTROLSUBE,
    VITE_BASE_PATH:
      window._env_?.VITE_BASE_PATH ?? import.meta.env.VITE_BASE_PATH,

    // Basemap (CARTO)
    VITE_CARTO_API_KEY:
      window._env_?.VITE_CARTO_API_KEY ?? import.meta.env.VITE_CARTO_API_KEY,

    // Google Analytics (only set in the production overlay)
    VITE_GOOGLE_ANALYTICS_ID:
      window._env_?.VITE_GOOGLE_ANALYTICS_ID ??
      import.meta.env.VITE_GOOGLE_ANALYTICS_ID,

    // Map date range filter (only set to "true" outside the production overlay)
    VITE_MAP_DATE_RANGE_ENABLED:
      window._env_?.VITE_MAP_DATE_RANGE_ENABLED ??
      import.meta.env.VITE_MAP_DATE_RANGE_ENABLED,

    // Líneas de recorrido del mapa: kill switch y tope de puntos por ambiente
    VITE_MAP_ROUTES_ENABLED:
      window._env_?.VITE_MAP_ROUTES_ENABLED ??
      import.meta.env.VITE_MAP_ROUTES_ENABLED,
    VITE_MAP_ROUTES_MAX_POINTS:
      window._env_?.VITE_MAP_ROUTES_MAX_POINTS ??
      import.meta.env.VITE_MAP_ROUTES_MAX_POINTS,
  };
};
